export interface DataLayer_Event<T> {
  event: DATA_LAYER_EVENT;
  data?: T;
  user?: DataLayer_User;
}

export interface DataLayer_User {
  email: string;
  phone?: string;
  first_name?: string;
  last_name?: string;
  id?: string;
}

export interface DataLayer_Ecommerce {
  currency: DATA_LAYER_ECOMMERCE_CURRENCY_OPTIONS;
  value: number;
  tax?: number;
  shipping?: number;
  tip?: number;
  coupon?: string;
  items: DataLayer_CartItem[];
}

export interface DataLayer_CartItem {
  item_id: string;
  item_name: string;
  price: number;
  discount: number;
  item_category: string;
  item_category2: string;
  item_brand?: string;
  promotion?: string;
  promotion_name?: string;
  quantity: number;
}

export interface DataLayer_BeginCheckout {
  ecommerce: DataLayer_Ecommerce;
}

export interface DataLayer_CheckAddress {
  delivery: {
    zip_code: string;
    in_area: boolean;
  };
  user: {
    email: string;
  };
}

export type DataLayer_DeliveryType = 'delivery' | 'pickup';

// PW uses pickup locations, so the sign-up funnel fires for pickup too. Pickup
// carries its own object instead of the address-oriented `delivery` block.
export interface DataLayer_SignUpFunnel_Pickup {
  location: string;
  day: string;
  zone: string;
}

export interface DataLayer_SignUpFunnel_DeliveryAddress {
  funnel_step: DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS.delivery_information;
  funnel_step_number: 1;
  delivery_type: DataLayer_DeliveryType;
  delivery?: {
    address: string;
    city: string;
    state: string;
    zip_code: string;
    zone: string;
    in_area: boolean;
  };
  pickup?: DataLayer_SignUpFunnel_Pickup;
  user: {
    email: string;
    id?: string;
  };
}

export interface DataLayer_SignUpFunnel_AccountDetails {
  funnel_step: DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS.account_details;
  funnel_step_number: 2;
  delivery_type: DataLayer_DeliveryType;
  delivery?: {
    zip_code: string;
    zone: string;
    in_area: boolean;
  };
  pickup?: DataLayer_SignUpFunnel_Pickup;
  user: {
    email: string;
    phone: string;
    first_name: string;
    last_name: string;
    id?: string;
  };
}

export interface DataLayer_SignUpFunnel_Complete {
  funnel_step: DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS.sign_up_complete;
  funnel_step_number: 3;
  delivery_type: DataLayer_DeliveryType;
  delivery?: {
    zip_code: string;
    zone: string;
    in_area: boolean;
  };
  pickup?: DataLayer_SignUpFunnel_Pickup;
  user: {
    id: string;
    logged_in: true;
    customer_type: 'new';
    email: string;
    phone: string;
    first_name: string;
    last_name: string;
  };
}

export type DataLayer_SignUpFunnel_Payload =
  | DataLayer_SignUpFunnel_DeliveryAddress
  | DataLayer_SignUpFunnel_AccountDetails
  | DataLayer_SignUpFunnel_Complete;

export enum DATA_LAYER_EVENT {
  check_address = 'check_address',
  sign_up_funnel = 'sign_up_funnel',
  begin_checkout = 'begin_checkout'
}

export enum DATA_LAYER_ECOMMERCE_CURRENCY_OPTIONS {
  usd = 'USD'
}

export enum DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS {
  delivery_information = 'delivery_information',
  account_details = 'account_details',
  sign_up_complete = 'sign_up_complete'
}
